<template>
	<transition name="menu">
		<div class="menu">
			<div class="overlay" @click="close"/>

			<div class="nav">
				<router-link :to="{name: 'products'}">Produkter</router-link>
				<router-link :to="{name: 'orders'}">Ordrehistorik</router-link>
				<router-link :to="{name: 'news'}">Nyheder</router-link>
				<router-link :to="{name: 'contact'}">Kontakt</router-link>
				<a @click="logout">Logud</a>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	methods: {
		close() {
			this.$emit("close");
		},
		logout() {
			this.$emit("logout");
		}
	}
};
</script>

<style lang="scss" scoped>
.menu {
	position: absolute;
	top: 100%;
	left: 0;
	right: 0;
	$t: 0.3s;

	&-enter-active, &-leave-active {
		transition: background-color $t; // enable child transitions
	}

	@at-root {
		.overlay {
			position: fixed;
			top: 0;
			bottom: 0;
			right: 0;
			left: 0;
			background-color: $black1;
			opacity: 0.1;

			.menu-enter-active &, .menu-leave-active & {
				transition: cubic(opacity, $t);
			}

			.menu-enter &, .menu-leave-to & {
				opacity: 0;
			}
		}

		.nav {
			background-color: $white1;
			position: relative;
			display: flex;
			flex-direction: column;
			align-items: center;
			padding: 24px 0;

			.menu-enter-active &, .menu-leave-active & {
				transition: cubic(transform, $t);
			}

			.menu-enter &, .menu-leave-to & {
				transform: translateY(-100%);
			}

			a {
				padding: 0.75em;
			}
		}
	}
}
</style>
